export default function studentid(state = '', action) {
  if (action.type === 'studentid') {
    return state = action.id;
  } else {
    return state;
  }
}
